/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import { Icon } from "antd-mobile";
import styled from "styled-components";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 3em;
  font-size: 0.9em;
`;

const StyleLeftContainer = styled.div`
  padding: 0 0.6em
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: flex-start;
  align-items: center;
`;

const StyleRightContainer = styled.div`
  padding: 0 0.6em
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: flex-end;
  align-items: center;
  color: red;
`;

class Topbar extends Component {
  render() {
    const { onLeftIconClick, onRightIconClick, backButton } = this.props;

    return (
      <StyledContainer>
        <StyleLeftContainer
          onClick={() => backButton && onLeftIconClick && onLeftIconClick()}
        >
          {backButton ? <Icon type="left" size="xs" /> : null}
          {backButton ? (
            <FormattedMessage
              id="app.back"
              defaultMessage="Back"
              description="Navigate to previous page"
            />
          ) : null}
        </StyleLeftContainer>
        <StyleRightContainer
          onClick={() => onRightIconClick && onRightIconClick()}
        >
          <FormattedMessage
            id="auth.asguest"
            defaultMessage="As a guest"
            description="Skip login at login page"
          />
          <Icon type="right" size="xs" color="red" />
        </StyleRightContainer>
      </StyledContainer>
    );
  }
}

Topbar.propTypes = {
  backButton: PropTypes.bool,
  onLeftIconClick: PropTypes.func,
  onRightIconClick: PropTypes.func
};

export default Topbar;



// WEBPACK FOOTER //
// ./src/containers/AuthPage/Topbar/index.js